import React, { useState, useEffect, useReducer, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Axios from "../../Axios";
import { toast } from "react-toastify";
import { Urls } from "../../Urls";
import {
  Activity,
  ActivityString,
  currentRequestTimeStamp,
  isMobile,
} from "../../Constants";
import Unauthorized from "../Unauthorized";
import { getKey, isDuplicate, getLocalDateTime, getUserDetails } from "./Utility";
import { validateInputs } from "../DiscoverNow/Utitlity";
import ReactGA from "react-ga";
import mixpanel from "mixpanel-browser";
import { UserApiContext } from "../UserDetailsContext/UserDetailsContext";

export const useFreightRatesLogic = () => {
  const location = useLocation();
  const push_history = useHistory();
  const { userDetails, setUserDetails } = useContext(UserApiContext);

  const [collapsed, setCollapsed] = useState(true);
  const [currentLaneList, setCurrentLaneList] = useState([]);
  const [allowedLanes, setAllowedLanes] = useState(4);
  const [maxlanes, setmaxlanes] = useState(0);
  const [allowedSessions, setAllowedSessions] = useState(0);
  const [history, setHistory] = useState([]);
  const [show, setShow] = useState(false);
  const [qualitativeInputs, setQualitativeInputs] = useState({});
  const [activeStep, setActiveStep] = useState(0);
  const [LSPCollapsed, setLSPCollapsed] = useState(true);
  const [userContent, setuserContent] = useState(<></>);
  const [togglerates, setTogglerates] = useState(true);
  const [lspLanes, setLspLanes] = useState([]);
  const [selectedLane, setSelectedLane] = useState({});
  const [sessionid, setSessionid] = useState("");
  const [allowedrate, setallowedrate] = useState("");
  const [allowedtransporter, setallowedtransporter] = useState("");
  const [upload_allowed, setupload_allowed] = useState(false);
  const [isTourOpen, setisTourOpen] = useState(false);
  const [firstTimeUser, setFirstTimeUser] = useState(false);
  const [excel_details, setExcel_details] = useState({});
  const [lspload, setlspload] = useState(true);
  const [attachments, setAttachments] = useState([]);
  const [alertPopupOpen, setAlertPopupOpen] = useState(false);
  const [alertPopupMessage, setAlertPopupMessage] = useState("");
  const [showNoCreditsModal, setShowNoCreditsModal] = useState(false);

  const [userInput, setUserInput] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      origin: "",
      destination: "",
      inputOrigin: "",
      inputDestination: "",
      options: [],
      selectedTruckType: "",
      isOptionsLoading: false,
      transitTime: "",
      freightRate: "",
      benchmarkavailableOptions: [],
      benchmarkunavailableOptions: [],
    }
  );

  const resetData = () => {
    setActiveStep(0);
    setUserInput({
      origin: "",
      destination: "",
      inputOrigin: "",
      inputDestination: "",
      options: [],
      selectedTruckType: "",
      isOptionsLoading: false,
      transitTime: "",
      freightRate: "",
      benchmarkavailableOptions: [],
      benchmarkunavailableOptions: [],
    });
  };

  const handleChange = (key, value) => {
    let newState = { [key]: value };
    if (
      key === "inputOrigin" ||
      key === "inputDestination" ||
      key === "origin" ||
      key === "destination"
    ) {
      newState.selectedTruckType = "";
      newState.options = [];
    }
    setUserInput(newState);
  };

  useEffect(() => {
    document.title = "LoRRI - Benchmark";
    ReactGA.pageview("BenchmarkNow");
    mixpanel.track(`User has viewed benchmark page`, {
      ApplicationName: `${Urls.mixpanelappname}`,
      ScreenName: "LoRRI-Benchmark",
      ModuleName: "landing_page",
      ActivityLog: "userViewedBenchmarkPage",
      Data: `None`,
      Definition: `User has viewed benchmark page`,
      ActivityType: "event_view",
      UserName: `${localStorage.getItem("userdetails")}`,
      UserEmail: `${localStorage.getItem("useremail")}`,
      CompanyName: `${localStorage.getItem("companyname")}`,
    });
    if (location.state ? location.state.from_search : null) {
      getSessionID();
    }
    if (document.getElementById("mySidepanel"))
      document.getElementById("mySidepanel").offsetWidth === 0
        ? setCollapsed(true)
        : setCollapsed(false);
    getExcelDetails();
    Activity([
      {
        screen: "My Freight Benchmark",
        module: "My Freight Benchmark",
        user_activity: ActivityString.benchmarknow,
        timestamp: currentRequestTimeStamp(),
      },
    ]);
    setisTourOpen(true);
  }, []);

  useEffect(() => {
    if (activeStep === 0 && setUserDetails) {
      getUserDetails()
        .then((res) => {
          if (res.data) {
            setUserDetails(res.data);
          }
        })
        .catch((err) => {
          console.log("Failed to refetch user details:", err);
        });
    }
  }, [activeStep, setUserDetails]);

  const getExcelDetails = () => {
    var current_excel_details = {};
    setlspload(true);
    Axios.get(`${Urls.benchmarnow}?field=get_excel_logs`)
      .then((res) => {
        if (res.data && res.data.length > 0) {
          current_excel_details = res.data[0];
          if (current_excel_details.excel_id) {
            setExcel_details(current_excel_details);
          }
        }
        setlspload(false);
      })
      .catch((e) => {
        console.log(e);
        setlspload(false);
      });
  };

  useEffect(() => {
    const setUserData = (decideUnauthorized = false) => {
      if (
        !userDetails ||
        !userDetails.policy ||
        !userDetails.policy.benchmarknow
      ) {
        return;
      }
      const {
        policy: { benchmarknow },
      } = userDetails;
      if (benchmarknow.allowed === "no") {
        setuserContent(<Unauthorized />);
        return;
      }
      setQualitativeInputs(userDetails.user_data ? userDetails.user_data : {});
      const {
        allowed_sessions = 0,
        allowed_lanes = 0,
        allowed_get_rates = "no",
        allowed_transporters = "no",
        allowed_upload = "no",
        history = [],
      } = benchmarknow;
      setAllowedSessions(allowed_sessions);
      setAllowedLanes(allowed_sessions === 0 ? 0 : allowed_lanes);
      setmaxlanes(allowed_lanes);
      setallowedrate(allowed_get_rates);
      setallowedtransporter(allowed_transporters);
      setupload_allowed(allowed_upload === "yes");
      setHistory(
        history.map((item) => ({
          session_id: item.session_id,
          session_name: `Report (${getLocalDateTime(
            item.session_created_on || new Date()
          )})`,
        }))
      );
    };
    setUserData(true);
  }, [userDetails]);

  const toggleNav = () => {
    if (document.getElementById("mySidepanel")) {
      if (document.getElementById("mySidepanel").offsetWidth === 0) {
        document.getElementById("mySidepanel").style.width = "25%";
        document.getElementById("mySidepanel").style.flexBasis = "25%";
        setCollapsed(false);
        if (activeStep === 1) {
          setLSPCollapsed(true);
        }
      } else {
        document.getElementById("mySidepanel").style.width = "0";
        document.getElementById("mySidepanel").style.flexBasis = "0%";
        setCollapsed(true);
        if (activeStep === 1) {
          setLSPCollapsed(false);
        }
      }
    }
  };

  const handleChangeForLanes = (value) => {
    setSelectedLane(value);
    lspLanes.map((item) => {
      var tlist = [];
      if (item.laneKey === value.laneKey) {
        item.benchmarknow_analysis.transporter_list.map((e) => {
          return tlist.push(e);
        });
      }
    });
  };

  const getDataForLane = async (
    origin,
    destination,
    inputorigin,
    inputdestination
  ) => {
    if (validateInputs(origin, inputorigin, destination, inputdestination)) {
      handleChange("isOptionsLoading", true);
      handleChange("options", []);
      const params = {
        searchFields: "truck",
        origin_lat: origin.location.lat,
        origin_lon: origin.location.lon,
        destination_lat: destination.location.lat,
        destination_lon: destination.location.lon,
        page: "benchmarknow",
      };
      const queryString = new URLSearchParams(params).toString();
      const getOptions = async (data) => {
        return Promise.all(
          data.filter((item) => {
            if (item.benchmark_available === true && item.name) {
              return;
            }
          })
        );
      };
      Axios.get(`${Urls.Autocomplete.Get.getlist}?${queryString}`)
        .then((res) => {
          if (res.data) {
            handleChange("isOptionsLoading", false);
            getOptions(res.data).then((mydata) => {
              handleChange("options", [
                {
                  options: res.data
                    .filter((item) => {
                      if (item.benchmark_available === true && item.name) {
                        return item;
                      }
                    })
                    .map((item) => {
                      return { ...item };
                    }),
                },
                {
                  options: [],
                },
              ]);
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const updateCurrentLaneList = (data) => {
    setCurrentLaneList(data);
  };

  const isValidUserData = () => {
    const isNumber = (value) =>
      new RegExp(/^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/).test(value);
    if (userInput.freightRate && !isNumber(userInput.freightRate)) {
      toast.error("Freight Rate can only be Number");
      return 0;
    }
    if (userInput.transitTime && !isNumber(userInput.transitTime)) {
      toast.error("Transit Time can only be Number");
      return 0;
    }
    return 1;
  };

  const addSelectedLane = () => {
    Activity([
      {
        screen: "My Freight Benchmark",
        module: "Add Lane ",
        user_activity: {
          origin: userInput.inputOrigin,
          destination: userInput.inputDestination,
          truck_type: userInput.selectedTruckType
            ? userInput.selectedTruckType.value
            : "",
        },
        timestamp: currentRequestTimeStamp(),
      },
    ]);
    mixpanel.track(`User has added lane in benchmark`, {
      ApplicationName: `${Urls.mixpanelappname}`,
      ScreenName: "LoRRI-Benchmark",
      ModuleName: "landing_page",
      ActivityLog: "userClickedAddLaneButton",
      Data: `${
        userInput &&
        userInput.inputOrigin &&
        userInput.inputDestination &&
        userInput.selectedTruckType
          ? userInput.inputOrigin +
            "to" +
            userInput.inputDestination +
            "," +
            userInput.selectedTruckType
          : "NA"
      }`,
      Definition: `User has added lane in benchmark`,
      ActivityType: "event_view",
      UserName: `${localStorage.getItem("userdetails")}`,
      UserEmail: `${localStorage.getItem("useremail")}`,
      CompanyName: `${localStorage.getItem("companyname")}`,
    });
    if (allowedLanes - currentLaneList.length < 1) {
      setShowNoCreditsModal(true);
    } else if (allowedLanes - currentLaneList.length !== 0 && activeStep === 0) {
      let laneKey = getKey(
        userInput.inputOrigin,
        userInput.inputDestination,
        userInput.selectedTruckType.value
      );
      if (!isDuplicate(currentLaneList, laneKey)) {
        if (isValidUserData()) {
          setCurrentLaneList([
            ...currentLaneList,
            {
              origin_coordinates: [
                userInput.origin.location.lon,
                userInput.origin.location.lat,
              ],
              destination_coordinates: [
                userInput.destination.location.lon,
                userInput.destination.location.lat,
              ],
              truck_type: userInput.selectedTruckType.value,
              laneKey: laneKey,
              origin: userInput.origin,
              destination: userInput.destination,
              origin_name: userInput.origin.location_name,
              destination_name: userInput.destination.location_name,
            },
          ]);
          if (isMobile()) {
            toast.info(
              "Lane Added, Click on Get LoRRI Benchmark button to proceed!"
            );
          }
        }
      } else {
        toast.error("This Entry Already Exists");
      }
    } else if (activeStep !== 0) {
      setAlertPopupMessage("You cannot add lanes at this moment since you are viewing results");
      setAlertPopupOpen(true);
    } else {
      setShowNoCreditsModal(true);
    }
  };

  const redirectUpgrade = (e) => {
    push_history.push({
      pathname: "/billing",
    });
    Activity([
      {
        screen: "Billings and Payments",
        module: "Billings and Payments",
        user_activity:
          "Premium Plans button clicked on side panel in my freight benchmark",
        timestamp: currentRequestTimeStamp(),
      },
    ]);
    mixpanel.track(`User has clicked premium plan button`, {
      ApplicationName: `${Urls.mixpanelappname}`,
      ScreenName: "LoRRI-Benchmark",
      ModuleName: "landing_page",
      ActivityLog: "userClickedPremiumPlan",
      Data: `None`,
      Definition: `User has clicked premium plan button`,
      ActivityType: "event_view",
      UserName: `${localStorage.getItem("userdetails")}`,
      UserEmail: `${localStorage.getItem("useremail")}`,
      CompanyName: `${localStorage.getItem("companyname")}`,
    });
  };

  const getSessionIDDirect = (networkOverride = null) => {
    const network = networkOverride ?? [
      {
        origin_coordinates: [userInput.origin.location.lon, userInput.origin.location.lat],
        destination_coordinates: [userInput.destination.location.lon, userInput.destination.location.lat],
        truck_type: userInput.selectedTruckType.value,
        laneKey: getKey(userInput.inputOrigin, userInput.inputDestination, userInput.selectedTruckType.value),
        origin: userInput.origin,
        destination: userInput.destination,
        origin_name: userInput.origin.location_name,
        destination_name: userInput.destination.location_name,
      },
    ];
    setCurrentLaneList(network);
    setAllowedLanes(allowedLanes - network.length);
    setShow(true);
    Axios.post(`${Urls.benchmarnow}?field=benchmarknow_analysis`, {
      network,
      session_created_on: new Date().toISOString(),
    })
      .then((res) => {
        if (res.data?.network) {
          setLspLanes(res.data.network);
          setActiveStep(1);
        }
        setShow(false);
      })
      .catch(() => setShow(false));
  };

  const getSessionID = () => {
    if (location.state ? location.state.data : null) {
      var network = [
        {
          destination: {
            coordinates: [
              parseFloat(location.state.data.destination_lon),
              parseFloat(location.state.data.destination_lat),
            ],
            location: {
              district: location.state.data.destination_district,
              label: location.state.data.inputDestination,
              lat: parseFloat(location.state.data.destination_lat),
              location: location.state.data.destination_name,
              lon: parseFloat(location.state.data.destination_lon),
              score: location.state.data.destination_score,
              state: location.state.data.destination_state,
              suggestion: location.state.data.inputDestination,
            },
            location_name: location.state.data.inputDestination,
          },
          destination_coordinates: [
            parseFloat(location.state.data.destination_lon),
            parseFloat(location.state.data.destination_lat),
          ],
          destination_name: location.state.data.inputDestination,
          laneKey: `${location.state.data.inputOrigin}_${location.state.data.inputDestination}_${location.state.data.truck_group}`,
          origin: {
            coordinates: [
              parseFloat(location.state.data.origin_lon),
              parseFloat(location.state.data.origin_lat),
            ],
            location: {
              district: location.state.data.origin_district,
              label: location.state.data.inputOrigin,
              lat: parseFloat(location.state.data.origin_lat),
              location: location.state.data.origin_name,
              lon: parseFloat(location.state.data.origin_lon),
              score: location.state.data.origin_score,
              state: location.state.data.origin_state,
              suggestion: location.state.data.inputOrigin,
            },
            location_name: location.state.data.inputOrigin,
          },
          origin_coordinates: [
            parseFloat(location.state.data.origin_lon),
            parseFloat(location.state.data.origin_lat),
          ],
          origin_name: location.state.data.inputOrigin,
          truck_type: location.state.data.truck_group,
        },
      ];
      setCurrentLaneList(network);
      setShow(true);
      Axios.post(`${Urls.benchmarnow}?field=benchmarknow_analysis`, {
        network: network,
        session_created_on: new Date().toISOString(),
      })
        .then((res) => {
          if (res.data && res.data.session_id && res.data.network) {
            setSessionid(res.data.session_id);
            setLspLanes(res.data.network);
            setAllowedLanes(allowedLanes - 1);
            setActiveStep(1);
          }
          setShow(false);
        })
        .catch((err) => {
          console.log(err);
          setShow(false);
        });
    } else {
      setShow(true);
      Axios.post(`${Urls.benchmarnow}?field=benchmarknow_analysis`, {
        network: currentLaneList,
        session_created_on: new Date().toISOString(),
      })
        .then((res) => {
          if (res.data && res.data.session_id && res.data.network) {
            setSessionid(res.data.session_id);
            setLspLanes(res.data.network);
            setAllowedLanes(allowedLanes - currentLaneList.length);
            setActiveStep(1);
          }
          setShow(false);
        })
        .catch((err) => {
          console.log(err);
          setShow(false);
        });
    }
    Activity([
      {
        screen: "My Freight Benchmark",
        module: "Get LoRRI Benchmark",
        user_activity: "Get LoRRI Benchmark button Clicked",
        timestamp: currentRequestTimeStamp(),
      },
    ]);
    mixpanel.track(`User has clicked get lorri benchmark`, {
      ApplicationName: `${Urls.mixpanelappname}`,
      ScreenName: "LoRRI-Benchmark",
      ModuleName: "landing_page",
      ActivityLog: "userClickedGetLorriBenchmark",
      Data: `None`,
      Definition: `User has clicked get lorri benchmark`,
      ActivityType: "event_view",
      UserName: `${localStorage.getItem("userdetails")}`,
      UserEmail: `${localStorage.getItem("useremail")}`,
      CompanyName: `${localStorage.getItem("companyname")}`,
    });
  };

  const closeTour = () => {
    setisTourOpen(false);
  };

  const previousEnquiry = () => {
    Activity([
      {
        screen: "My Freight Benchmark",
        module: "My Freight Benchmark",
        user_activity: "Previous Enquiries link clicked",
        timestamp: currentRequestTimeStamp(),
      },
    ]);
    mixpanel.track(`User has clicked on view previous enquiry button`, {
      ApplicationName: `${Urls.mixpanelappname}`,
      ScreenName: "LoRRI-Benchmark",
      ModuleName: "landing_page",
      ActivityLog: "userClickedViewPreviousEnquiryButton",
      Data: `None`,
      Definition: `User has clicked on view previous enquiry button`,
      ActivityType: "event_view",
      UserName: `${localStorage.getItem("userdetails")}`,
      UserEmail: `${localStorage.getItem("useremail")}`,
      CompanyName: `${localStorage.getItem("companyname")}`,
    });
  };

  return {
    // state
    collapsed,
    currentLaneList,
    allowedLanes,
    maxlanes,
    allowedSessions,
    history,
    show,
    qualitativeInputs,
    setQualitativeInputs,
    activeStep,
    setActiveStep,
    LSPCollapsed,
    setLSPCollapsed,
    userContent,
    togglerates,
    setTogglerates,
    lspLanes,
    setLspLanes,
    selectedLane,
    setSelectedLane,
    sessionid,
    setSessionid,
    allowedrate,
    setallowedrate,
    allowedtransporter,
    setallowedtransporter,
    upload_allowed,
    setupload_allowed,
    isTourOpen,
    firstTimeUser,
    excel_details,
    lspload,
    attachments,
    setAttachments,
    userInput,
    userDetails,
    setShow,
    alertPopupOpen,
    setAlertPopupOpen,
    alertPopupMessage,
    showNoCreditsModal,
    setShowNoCreditsModal,
    // functions
    resetData,
    handleChange,
    toggleNav,
    handleChangeForLanes,
    getDataForLane,
    updateCurrentLaneList,
    addSelectedLane,
    redirectUpgrade,
    getSessionID,
    getSessionIDDirect,
    getExcelDetails,
    closeTour,
    previousEnquiry,
  };
};
